import { HANDLE_ERROR, ROOT_URL } from '../../constants';
import moment from 'moment';
import axios from 'axios';
import { saveAs } from 'file-saver';


export const getSevenDayTime = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/time`;
    return axios
        .get(url)
        .then(response => {
            if (response.status !== 500) {
                return response.data;
            }
            else {
                return []
            }
        })
        .catch(err => console.log(err))
};

export const getWordsPerMinute = (studentId,startDate,endDate) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/words-per-minute${(startDate && endDate) ? `?startDate=${startDate}&endDate=${endDate}` : "" }`;
    return axios
        .get(url)
        .then(response => {
            if (response.status !== 500) {
                return response.data;
            }
            else {
                return []
            }
        })
        .catch(err => console.log(err))
}

// getSkipRate //! _OLD version missing; see OE-BuddyBooks dashboard.js action or swagger for new version
// getFluency //! _OLD version missing; see OE-BuddyBooks dashboard.js action or swagger for new version

export const getAccuracy = (studentId, startDate, endDate) => {
    // const url_OLD = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/accuracy${(startDate && endDate) ? `?startDate=${startDate}&endDate=${endDate}` : "" }`;
    // Base URL for the accuracy endpoint
    let url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/new/accuracy`;
    
    // Create params object
    const params = {};
    if (studentId) {
        params.studentId = studentId;
    }
    if (startDate) {
        params.startDate = startDate;
    }
    if (endDate) {
        params.endDate = endDate;
    }
    
    // Add params to URL if they exist
    if (Object.keys(params).length > 0) {
        url += '?';
        const paramStrings = [];
        
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                paramStrings.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
            }
        }
        
        url += paramStrings.join('&');
    }
    
    return axios
        .get(url)
        .then(response => {
            if (response.status !== 500) {
                return response.data;
            }
            else {
                return [];
            }
        })
        .catch(err => {
            console.log(err);
            return [];
        });
};

export const getDashboardChartData = (studentId, startDate, endDate) => {
    // Base URL for the chart data endpoint
    let url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/new/chart-data`;
    
    // Create params object
    const params = {};
    if (studentId) {
        params.studentId = studentId;
    }
    if (startDate) {
        params.startDate = startDate;
    }
    if (endDate) {
        params.endDate = endDate;
    }
    
    // Add params to URL if they exist
    if (Object.keys(params).length > 0) {
        url += '?';
        const paramStrings = [];
        
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                paramStrings.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
            }
        }
        
        url += paramStrings.join('&');
    }
    
    return axios
        .get(url)
        .then(response => {
            if (response.status !== 500) {
                // Process the response to ensure it has the expected properties
                const data = response.data || {};
                
                // Make sure we return an object with all the expected properties
                return {
                    studentId: data.studentId || null,
                    fluency: data.fluencyData || [],
                    skipRate: data.skipRateData || [],
                    accuracy: data.accuracyData || [],
                    reviewModes: data.reviewModes || [],
                    summary: data.summary || null,
                    quickActions: data.quickActions || [],
                    // Also include the nested structure if it exists
                    [studentId]: {
                        fluency: data.fluencyData || [],
                        skipRate: data.skipRateData || [],
                        accuracy: data.accuracyData || [],
                        reviewModes: data.reviewModes || [],
                        summary: data.summary || null,
                        quickActions: data.quickActions || []
                    }
                };
            }
            else {
                return {
                    studentId: null,
                    fluency: [],
                    skipRate: [],
                    accuracy: [],
                    reviewModes: [],
                    summary: null,
                    quickActions: [],
                    [studentId]: {
                        fluency: [],
                        skipRate: [],
                        accuracy: [],
                        reviewModes: [],
                        summary: null,
                        quickActions: []
                    }
                };
            }
        })
        .catch(err => {
            console.log(err);
            return {
                studentId: null,
                fluency: [],
                skipRate: [],
                accuracy: [],
                reviewModes: [],
                summary: null,
                quickActions: [],
                [studentId]: {
                    fluency: [],
                    skipRate: [],
                    accuracy: [],
                    reviewModes: [],
                    summary: null,
                    quickActions: []
                }
            };
        });
};

export const getProgress = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/progress`;
    return axios
        .get(url)
        .then(response => {
            if (response.status !== 500) {
                return response.data;
            }
            else {
                return []
            }
        })
        .catch(err => console.log(err))
};

export const getPhonemes = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/phoneme`;
    return axios
        .get(url)
        .then(response => {
            if (response.status !== 500) {
                return response.data;
            }
            else {
                return []
            }
        })
        .catch(err => console.log(err))
};

export const getPhonemesSpecific = (studentId, phoneme) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/phoneme/${phoneme}`;
    return axios.get(url)
        .then(response => {
            if (response.status !== 500) {
                console.log('analysis phoneme specific', response.data);
                return response.data;
            }
            else {
                return []
            }
        })
}

export const getReviewData = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/new/reviews`;
    return axios.get(url)
        .then(response => {
            if (response.status !== 500) {
                console.log('getReview response', response.data);
                return response.data;
            }
            else {
                return []
            }
        })
}

export const getReviewData_OLD = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/reviews`;
    return axios.get(url)
        .then(response => {
            if (response.status !== 500) {
                console.log('getReview response', response.data);
                return response.data;
            }
            else {
                return []
            }
        })
}

export const getReadingTime = (studentId) => {
    const url = `${ROOT_URL}/students/${studentId}/buddy-books/dashboard/time/v2`;
    return axios.get(url)
        .then(response => {
            if (response.status !== 500) {
                console.log('getReading response', response.data);
                return response.data;
            }
            else {
                return []
            }
        })
}
export const getWPMBooks = async (studentId, bookIds) => {
    let proms = bookIds.map(id => axios.get(`${ROOT_URL}/students/${studentId}/story/${id}`)
        .then(r => r.data));
    return Promise.all(proms).then(res => {
        return res;
    })
}